var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineSystemsLogoutBoxLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 15H5.00004V16.6667H15V3.33333H5.00004V5H3.33337V2.5C3.33337 2.27899 3.42117 2.06703 3.57745 1.91075C3.73373 1.75447 3.94569 1.66667 4.16671 1.66667H15.8334C16.0544 1.66667 16.2663 1.75447 16.4226 1.91075C16.5789 2.06703 16.6667 2.27899 16.6667 2.5V17.5C16.6667 17.721 16.5789 17.933 16.4226 18.0893C16.2663 18.2455 16.0544 18.3333 15.8334 18.3333H4.16671C3.94569 18.3333 3.73373 18.2455 3.57745 18.0893C3.42117 17.933 3.33337 17.721 3.33337 17.5V15ZM5.00004 9.16667H10.8334V10.8333H5.00004V13.3333L0.833374 10L5.00004 6.66667V9.16667Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSystemsLogoutBoxLine);
export default __webpack_public_path__ + "static/media/Line__Systems--logout-box-line.ca244130075013b7f1eef1c5dd76388e.svg";
export { ForwardRef as ReactComponent };